import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
} from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Menu } from 'antd';
import {Day} from "../../lib/bl";
import {Link} from "react-router-dom";

type MenuItem = Required<MenuProps>['items'][number];

function getItem(
  label: React.ReactNode,
  key: React.Key,
  icon?: React.ReactNode,
  children?: MenuItem[],
  type?: 'group',
  danger?: boolean,
): MenuItem {
  return {
    key,
    icon,
    children,
    label,
    type,
    danger,
  } as MenuItem;
}

interface MainMenuProps {
  tableOfContents: {string: Day[]}
}

const MainMenu = (props: MainMenuProps) => {
  const {tableOfContents} = props
  const [collapsed, setCollapsed] = useState(false);

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  let items: MenuItem[] = [
    getItem(<Link to={'/profile'}>Особистий кабінет</Link>, '1', <PieChartOutlined />),
  ];

  for (const chapter of Object.keys(tableOfContents)) {
    let chapterMenuItems = []
    // @ts-ignore
    for (const dayData of tableOfContents[chapter]) {
      const href = `/course/product-ua-1/chapter/${dayData['chapterId']}/day/${dayData['day']}`
      chapterMenuItems.push(getItem(
        (<a href={href}>{dayData['title']}</a>),
        dayData['day']+chapter,
        undefined,
        undefined,
        undefined,
        !dayData['isComplited']
      ))
    }
    items.push(getItem(chapter, chapter, undefined, chapterMenuItems))
  }

  return (
    <>
      <Button type="primary" onClick={toggleCollapsed} style={{ marginBottom: 10 }}  size={"large"}>
        {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
      </Button>
      <Menu
        hidden={!collapsed}
        mode="inline"
        theme="dark"
        items={items}
      />
    </>
  );
};

export default MainMenu;